import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import { ToastContainer } from "react-toastify";
import { Breadcrumb, Layout } from "antd";
import "react-toastify/dist/ReactToastify.css";

import MainFooter from "../../components/layout/MainFooter";
const { Content } = Layout;
const PaymentLayout = ({ children, noNavbar, noFooter }) => (
  <Layout>
    <Container className="layout" fluid>
      <ToastContainer />
      <Row>
        <Col
          className="main-content p-0 m-0"
          lg={{ size: 12 }}
          md={{ size: 12 }}
          sm="12"
          tag="main"
        >
          <Content style={{ padding: "0 50px" }}>
            <Row lg={{ size: 12 }} md={{ size: 12 }} sm="12">
              <Col lg={{ size: 6 }} md={{ size: 6 }} sm="6">
                <Breadcrumb style={{ margin: "16px 0" }}>
                  <Breadcrumb.Item>Front Office</Breadcrumb.Item>
                  <Breadcrumb.Item>Payment</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
              <Col
                lg={{ size: 6 }}
                md={{ size: 6 }}
                sm="6"
                style={{ margin: "16px 0" }}
                align="right"
              >
                <Link
                  to="/main"
                  onClick={() => {
                    localStorage.clear();
                  }}
                  className="text-light"
                  style={{ textDecoration: "none" }}
                >
                  <i className="material-icons">lock</i> Lock out
                </Link>
              </Col>
            </Row>
            <div className="site-layout-content">{children}</div>
          </Content>
        </Col>
      </Row>
      <Row>
        <Col
          className="main-content p-0"
          lg={{ size: 12 }}
          md={{ size: 12 }}
          sm="12"
          tag="main"
        >
          {!noFooter && <MainFooter />}
        </Col>
      </Row>
    </Container>
  </Layout>
);

PaymentLayout.propTypes = {
  noNavbar: PropTypes.bool,
  noFooter: PropTypes.bool,
};

PaymentLayout.defaultProps = {
  noNavbar: false,
  noFooter: false,
};

export default PaymentLayout;
